import React, { useState, useEffect, useRef } from "react";
import { colors } from "../assets/js/common";

const ClampWithReadMore = ({ text, lines = 4, redMoreClick, ...props }) => {
  const [isOverflow, setIsOverflow] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (contentRef.current) {
        setIsOverflow(
          contentRef.current.scrollHeight > contentRef.current.offsetHeight
        );
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => window.removeEventListener("resize", checkOverflow);
  }, [text]);

  const toggleExpand = () => setExpanded(!expanded);

  return (
    <div className="clamp-with-read-more" {...props}>
      <div
        ref={contentRef}
        className={`content ${expanded ? "expanded" : ""}`}
        style={{ WebkitLineClamp: expanded ? "unset" : lines }}
      >
        {text}
      </div>
      {isOverflow && (
        // <button className="read-more" onClick={toggleExpand}>
        //   {expanded ? "Read Less" : "Read More"}
        // </button>
        <button
          type="button"
          className="tertiaryButton clamp-readMore"
          style={{
            border: "none",
            background: "transparent",
            fontSize: "14px",
            textDecoration: "underline",
            padding: 0,
            color: colors["orange-1"],
          }}
          onClick={redMoreClick}
        >
          read more
        </button>
      )}
    </div>
  );
};

export default ClampWithReadMore;
